/* eslint-disable no-unused-vars */
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router";

import { selectUser } from "Features/user";
import { usePrevious } from "./usePrevious";
import { selectAuth } from "Features/auth";

const allowedPageWithoutUser = new Set(["login", "register", "recover", "set_pass"]);

export const useProtectRoutes = () => {
	const token = useSelector(selectUser.token);
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;
	const currentProcess = location.pathname.split("/")[1];
	const currentPage = location.pathname.split("/")[2];
	const user = useSelector(selectUser.data);
	const userFetch = useSelector(selectAuth.fetch);
	const prevFetch = usePrevious(userFetch);

	useEffect(() => {
		if (!userFetch && prevFetch) {
			chooseNavigation();
		}
	}, [user, token, userFetch]);

	function chooseNavigation() {
		if (currentPath === "/") {
			if (user && user?.first_name && user?.last_name && user?.birthday) {
				navigate("/main");
				return;
			} else {
				navigate("/auth");
			}
		}
		if (currentProcess !== "auth" && !user) {
			localStorage.setItem("targetPath", currentPath);
			navigate("/auth");
		}
		if (currentProcess === "auth") {
			authNavigationSwitcher();
		}
	}

	function authNavigationSwitcher() {
		if (!user) {
			if (allowedPageWithoutUser.has(currentPage)) return;
			navigate("/auth/login");
			return;
		}
		if (user) {
			if (!user.email_address) {
				navigate("/auth/check_mail");
				return;
			}
			if (!user.first_name || !user.last_name || !user.birthday) {
				navigate("/auth/postreg");
				return;
			}
			const path = localStorage.getItem("targetPath");
			if (path?.length) {
				localStorage.setItem("targetPath", "/");
				navigate(path);
			} else {
				navigate("/main");
			}
			return;
		}
	}
};
